import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import Vconsole from "vconsole";
import { createApp } from "vue";
import App from "./App.vue";
import "./main.css";
import pinia from "./pinia";
import router from "./router";

// import * as ElementPlusIconsVue from "@element-plus/icons-vue";

const app = createApp(App);
if (process.env.NODE_ENV === "dev") {
  app.use(new Vconsole() as any);
}
// app.use(new Vconsole());
app.use(ElementPlus).use(router).use(pinia).mount("#app");

// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component);
// }
